import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 92 92",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 92 92\" id=\"close\">\n  <path fill=\"#000\" fill-rule=\"evenodd\" d=\"m21.958 67.213 45.255-45.255 4.243 4.243L26.2 71.456l-4.243-4.243Z\" clip-rule=\"evenodd\" />\n  <path fill=\"#000\" fill-rule=\"evenodd\" d=\"m25.494 21.251 45.255 45.255-4.243 4.243-45.255-45.255 4.243-4.243Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol